module.exports = __webpack_public_path__ + "images/68a1c9997fd9d2854a5d6bdc476427f5.svg";